export const CUSTOMERS_GET = '@CUSTOMERS_GET'
export const CUSTOMERS_GET_SUCCESS = '@CUSTOMERS_GET_SUCCESS'
export const CUSTOMERS_GET_FAILURE = '@CUSTOMERS_GET_FAILURE'

export default {
  CUSTOMERS_GET,
  CUSTOMERS_GET_SUCCESS,
  CUSTOMERS_GET_FAILURE
}
